import { Component, EventEmitter, OnInit, Output } from '@angular/core'

@Component({
    selector: 'app-button-show-big-images',
    templateUrl: './button-show-big-images.component.html',
    styleUrls: ['./button-show-big-images.component.css',
        '../../../../../../stagingcss/image-viewer.component.css',
        '../../../../../../stagingcss/root-ui-view.component.css',
        '../../../../../../stagingcss/ui-schema-table-form.component.css',
        '../../../../../../stagingcss/main-body.component.css',
        '../../../../../../stagingcss/lui-select.component.css',
        '../../../../../../stagingcss/canvas.component.css',
    ],
})
export class ButtonShowBigImagesComponent implements OnInit {
    videoPadding
    @Output() _click = new EventEmitter<any>()

    constructor() {
    }

    ngOnInit() {

    }

    callDownload() {
        this._click.emit()
    }
}



// WEBPACK FOOTER //
// ./src/app/app_manager/modal/client-detail/top/showBigImages/button-show-big-images/button-show-big-images.component.ts